export default "__VITE_ASSET__2c38f6fa__"